import offeringService from '@/modules/purchasable/services/offeringService';

const state = {
  packageOfferings: null,
  appOfferings: null,
  bundledOfferingsByParent: {},
};

const mutations = {
  setPackageOfferings(state, offerings) {
    state.packageOfferings = offerings;
  },
  setAppOfferings(state, offerings) {
    state.appOfferings = offerings;
  },
  setBundledOfferings(state, { parentOfferingUid, offerings }) {
    state.bundledOfferingsByParent = { ...state.bundledOfferingsByParent, [parentOfferingUid]: offerings };
  },
};

const actions = {
  async fetchPackageOfferings({ commit, state }) {
    if (state.packageOfferings) return;

    const offerings = await offeringService.fetchOfferings({ type: 'package', isActive: true });

    if (Array.isArray(offerings)) {
      commit('setPackageOfferings', offerings);
    }
  },
  async fetchAppOfferings({ commit, state }, { force = false } = {}) {
    if (state.appOfferings && !force) return state.appOfferings;

    const offerings = await offeringService.fetchAppOfferings();

    if (!Array.isArray(offerings)) throw new Error('Failed to fetch app offerings');

    commit('setAppOfferings', offerings);
    return offerings;
  },
  async fetchBundledOfferings({ commit, state }, parentOfferingUid) {
    if (!parentOfferingUid) return [];
    if (state.bundledOfferingsByParent[parentOfferingUid]) return state.bundledOfferingsByParent[parentOfferingUid];

    const bundles = await offeringService.fetchBundledOfferings(parentOfferingUid);
    const offerings = await Promise.all(
      bundles.map((bundle) => offeringService.fetchOfferingByUid(bundle.bundled_offering_uid)),
    );
    const resolved = offerings.filter(Boolean);

    commit('setBundledOfferings', { parentOfferingUid, offerings: resolved });
    return resolved;
  },
};

const getters = {
  packageOfferings: (state) => state.packageOfferings,
  appOfferings: (state) => state.appOfferings,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
